/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: customerCodesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Class of Services module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteCustomerCodeById as deleteCustomerCodeByIdApi } from './api';

/**
 * Shared helpers for Customer Codes module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Customer Code in the form.
 * Pattern: /pbx/class-of-service/customer-codes/new?duplicate={id}
 */
export const getCustomerCodeDuplicateUrl = (id: string | number): string =>
  `/pbx/class-of-service/customer-codes/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Customer Code id.
 */
export const navigateToCustomerCodeDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getCustomerCodeDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Customer Code by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteCustomerCodeById = deleteCustomerCodeByIdApi;



